import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { injectLocalStorage } from 'ngxtension/inject-local-storage';
import { lastValueFrom } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IntakeTelemetry {
  private readonly http = inject(HttpClient);
  private readonly tokenStorage = injectLocalStorage('session-token');
  private readonly telemetryUrl = environment.intakeApiBaseUrl
    ? `${environment.intakeApiBaseUrl}/telemetry`
    : '/intake/telemetry';

  /**
   * Send a telemetry event (non-PII)
   * @param eventType e.g. 'widget_loaded', 'field_changed', 'error'
   * @param details   additional event details (anonymous only)
   */
  send(eventType: string, details: Record<string, unknown> = {}) {
    const token = this.tokenStorage();
    if (!token) return;

    // Only send anonymous/session-level data
    const payload = {
      eventType,
      details,
      timestamp: Date.now(),
    };

    return lastValueFrom(
      this.http.post(this.telemetryUrl, payload, {
        headers: { Authorization: `Bearer ${token}` },
      }),
    );
  }
}
